import IssuableDetail from "../issuables/IssuableDetail";
import {Certification, IssuableController} from "@/components/provider/cards/issuables/IssuableModels";
import {UserRoleEnum} from "@/enums/userRolesEnum";
import Vue from "vue";

export default Vue.component('certification-detail', {
  name: 'CertificationDetail',
  props : {
    certification: {
      type: Object as () => Certification
    },
    systemCertifications: {
      type: Array as () => any[]
    },
    issuableController : Object as () => IssuableController<any>
  },

  components: {
    IssuableDetail
  },

  computed: {
    isProviderUser (): boolean {
      return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
    }
  },

  methods: {
    certificationChange(providerCertification: Certification) {
      this.systemCertifications.forEach(function (systemCertification: any) {
        if (providerCertification.certificationTypeId === systemCertification.id) {
          providerCertification.certification = systemCertification.certification;
          providerCertification.certificationShortName = systemCertification.certificationShortName;
          return;
        }
      })
    },

    async toggleEditCertification(certification: Certification) {
      this.$emit('certSelected', certification.id);
    },

    reEmitStaleDataEvent() {
      this.$emit('staleData');
    },
    reEmitCancel(issuable : any) {
      this.$emit('cancel', issuable);
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/provider/cards/certifications/CertificationDetail.ts